module.exports = require('./src/slave_gateway');


//////////////////
// WEBPACK FOOTER
// ./~/@nsftx/seven-gravity-gateway/slave.js
// module id = 216
// module chunks = 0